<template>
    <div class="black-bg-2" v-if="isAdoptionManage">
        <div class="white-bg-2">
            <div class="py-4 container-fluid">
                <div class="row">
                    <div class="col-md-12">
                        <div class="card editArea">
                            <div class="card-header pb-0">
                                <div class="row">
                                    <div class="col-md-3">
                                        <button class="btn btn-outline-danger btn-sm ms-auto w-100" v-if="isModify && (this.$store.state.login.userType == '관리자' || this.$store.state.login.loginID == 'developer01' || this.$store.state.login.loginID == 'developer02')" @click="deleteAdoptInfo()">삭제</button>
                                    </div>
                                    <div class="col-md-1">

                                    </div>
                                    <div class="col-md-1 onmaum-text-right">

                                    </div>
                                    <div class="col-md-1 onmaum-text-right">
                                        <i class="far fa-star onmaum-font-2rem onmaum-text-alarm onmaum-text-cursor" v-if="!isFavorite" @click="setFavor();"></i><!-- 미선택 -->
                                        <i class="fas fa-star onmaum-font-2rem onmaum-text-alarm onmaum-text-cursor" v-if="isFavorite" @click="setFavor();"></i><!-- 선택 -->
                                    </div>
                                    <div class="col-md-3">
                                        <button class="btn btn-outline-secondary btn-sm ms-auto w-100" @click="insertMode">취소</button>
                                    </div>
                                    <div class="col-md-3">
                                        <button class="btn btn-warning btn-sm ms-3 w-100" v-if="isModify && (this.$store.state.login.userType == '관리자' || this.$store.state.login.loginID == 'developer01' || this.$store.state.login.loginID == 'developer02')" @click="modifyAdoptInfo">저장</button>
                                        <button class="btn btn-success btn-sm ms-auto w-100" v-if="!isModify && (this.$store.state.login.userType == '관리자' || this.$store.state.login.loginID == 'developer01' || this.$store.state.login.loginID == 'developer02')" @click="insertAdoptInfo">추가</button>
                                    </div>
                                </div>
                            </div>
                            <div class="card-body onmaum-overflow-y onmaum-overflow-type02">

                                <div class="row">
                                    <!-- 사진 영역 -->
                                    <div class="col-12 col-lg-3 onmaum-dflex-column onmaum-v-center onmaum-h-center">
                                        <!-- 사진 없을 때 -->
                                        <div class="overflow-hidden" style="border-radius: 1rem; aspect-ratio: 1/1;" v-if="petImage[0]?false:true">
                                            <img src="/img/icons/logo_icon.png" style="width: 100%; height: 100%;"/>
                                        </div>
                                        <!-- 사진 있을 때 -->
                                        <div class="overflow-hidden" style="border-radius: 1rem; aspect-ratio: 1/1; max-width: 100%; max-height: 100%;" v-if="petImage[0]?true:false">
                                            <swiper :modules="modules"
                                                    v-bind="swiperOptions"  style="width: 100%; height: 100%;">
                                                <swiper-slide v-for="(image, i) in petImage" :key="i">
                                                    <img :src="image.location" style="width: 100%; height: 100%;"/>
                                                </swiper-slide>
                                            </swiper>
                                        </div>
                                        <div class="my-2">
                                            <div class="filebox2">
                                                <label class="btn btn-primary" for="petImage">사진 변경</label>
                                                <input type="file" id="petImage" multiple="true" @change="petImageChanged"> 
                                            </div>
                                        </div>
                                    </div>

                                    <!-- 기본 정보 영역 -->
                                    <div class="col-12 col-lg-9">
                                        <table class="table" style="width: 100%">
                                            <colgroup>
                                                <col style="width: 15%">
                                                <col style="width: 35%">
                                                <col style="width: 15%">
                                                <col style="width: 35%">
                                            </colgroup>
                                            <tr>
                                                <th class="text-center align-content-center">
                                                    <label for="petName" class="form-control-label fs-5 text-right">이름</label>
                                                </th>
                                                <td>
                                                    <input id="petName" class="form-control invalid" type="text" v-model="petName" placeholder="이름"/>
                                                </td>
                                                <th class="text-center">
                                                    <label for="petGender" class="form-control-label fs-5">성별</label>
                                                </th>
                                                <td>
                                                    <select id="petGender" class="form-select" v-model="petGender">
                                                        <option value="">성별선택</option>
                                                        <option value="0">수컷</option>
                                                        <option value="1">암컷</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text-center">
                                                    <label for="petBirth" class="form-control-label fs-5">생일</label>
                                                </th>
                                                <td>
                                                    <input id="petBirth" class="form-control invalid" type="text" v-model="petBirth" placeholder="생일"/>
                                                </td>
                                                <th class="text-center">
                                                    <label for="petAge" class="form-control-label fs-5">나이</label>
                                                </th>
                                                <td>
                                                    <input id="petAge" class="form-control invalid" type="text" v-model="petAge" placeholder="나이"/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text-center">
                                                    <label for="petWeight" class="form-control-label fs-5">몸무게(kg)</label>
                                                </th>
                                                <td>
                                                    <input id="petWeight" class="form-control invalid" type="text" v-model="petWeight" placeholder="몸무게"/>
                                                </td>
                                                <th class="text-center">
                                                    <label for="petKind" class="form-control-label fs-5">구분</label>
                                                </th>
                                                <td>
                                                    <select id="petKind" class="form-select" v-model="petKind">
                                                        <option value="">선택</option>
                                                        <option value="0">개</option>
                                                        <option value="1">고양이</option>
                                                    </select>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text-center">
                                                    <label for="petBreed" class="form-control-label fs-5">품종</label>
                                                </th>
                                                <td>
                                                    <input id="petBreed" class="form-control invalid" type="text" v-model="petBreed" placeholder="품종"/>
                                                </td>
                                                <th class="text-center">
                                                    <label for="petRegNum" class="form-control-label fs-5">동물등록번호</label>
                                                </th>
                                                <td>
                                                    <input id="petRegNum" class="form-control invalid" type="text" v-model="petRegNum" placeholder="동물등록번호"/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text-center">
                                                    <label class="form-control-label fs-5">입양여부</label>
                                                </th>
                                                <td>
                                                    <div class=text-center>
                                                        <div class="form-check form-switch d-inline-block ">
                                                            <input class="form-check-input" type="checkbox" role="switch" id="petAdopt" v-model="petAdopt" :style="petAdopt?`background-color:#2dce89; border-color: #2dce89;`:''">
                                                                <label class="form-check-label" for="petAdopt">
                                                                <span class="badge bg-success" v-if="petAdopt">입양</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <th class="text-center">
                                                    <label for="petAdoptDate" class="form-control-label fs-5">입양일</label>
                                                </th>
                                                <td>
                                                    <input id="petAdoptDate" class="form-control invalid" type="text" v-model="petAdoptDate" placeholder="입양일"/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text-center">
                                                    <label class="form-control-label fs-5">중성화여부</label>
                                                </th>
                                                <td>
                                                    <div class=text-center>
                                                        <div class="form-check form-switch d-inline-block ">
                                                            <input class="form-check-input" type="checkbox" role="switch" id="petNeutral" v-model="petNeutral">
                                                                <label class="form-check-label" for="petNeutral">
                                                                <span class="badge bg-primary" v-if="petNeutral">중성화</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </td>
                                                <th class="text-center">
                                                    <label class="form-control-label fs-5">3개월 내 치료력</label>
                                                </th>
                                                <td>
                                                    <div class=text-center>
                                                        <div class="form-check form-switch d-inline-block ">
                                                            <input class="form-check-input" type="checkbox" role="switch" id="petTreat" v-model="petTreat">
                                                                <label class="form-check-label" for="petTreat">
                                                                <span class="badge onmaum-badge-sns" v-if="petTreat">치료함</span>
                                                            </label>
                                                        </div>
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text-center">
                                                    <label for="petMedical" class="form-control-label fs-5">예방접종 정보</label>
                                                </th>
                                                <td colspan="3">
                                                    <input id="petMedical" class="form-control invalid" type="text" v-model="petMedical" placeholder="예방접종 정보"/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text-center">
                                                    <label for="petHealth" class="form-control-label fs-5">건강상태</label>
                                                </th>
                                                <td colspan="3">
                                                    <input id="petHealth" class="form-control invalid" type="text" v-model="petHealth" placeholder="건강상태"/>
                                                </td>
                                            </tr>
                                            <tr>
                                                <th class="text-center">
                                                    <label for="petRescue" class="form-control-label fs-5">구조사유</label>
                                                </th>
                                                <td colspan="3">
                                                    <input id="petRescue" class="form-control invalid" type="text" v-model="petRescue" placeholder="구조사유"/>
                                                </td>
                                            </tr>
                                        </table>
                                    </div>

                                    <!-- 기타 정보 영역 -->
                                    <hr />
                                    <div class="col-md-12 mb-3 memoArea">
                                        <label class="form-control-label fs-5">메모</label>
                                        <div class="row mb-3" v-for="(memo, i) in petMemo" :key="i">
                                            <div class="col-md-1 text-center text-sm font-weight-bolder opacity-8 my-auto">
                                                메모 {{ i + 1 }}
                                            </div>
                                            <div class="col-md-2">
                                                <VueDatePicker v-model="petMemoDate[i]" ref="vdMemoDate" locale="kr" cancelText="취소" selectText="선택" :format="formatMemoDate(i)" :placeholder="'날짜' + (i + 1)"></VueDatePicker>
                                            </div>
                                            <div class="col-md-8">
                                                <input class="petMemo form-control invalid" type="text" v-model="petMemo[i]" :placeholder="'메모' + (i + 1)">
                                            </div>
                                            <button class="col-md-1 btn btn-outline-danger p-1 my-auto" @click="deleteMemo(i)">
                                                삭제
                                            </button>
                                        </div>
                                    
                                        <div class="text-center">
                                            <button class="btn btn-outline-primary btn-sm ms-auto" @click="addMemo">메모 추가</button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import { Navigation, Pagination, Scrollbar } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/vue';

export default {
    name: 'AdoptionManage',

    props: {
        isAdoptionManage: Boolean,
        adoptionID: Number,
        manageMode: String,
        toggleManage: Function,
    },

    components: {
        Swiper,
        SwiperSlide,
    },

    data() {
        return {
            isFavorite: false,
            
            petImage: [],
            petName: '',
            petGender: '',
            petBirth: '',
            petAge: '',
            petWeight: '',
            petKind: '',
            petBreed: '',
            petRegNum: '',
            petAdopt: false,
            petAdoptDate: '',
            petNeutral: false,
            petTreat: false,
            petMedical: '',
            petHealth: '',
            petRescue: '',
            
            petMemoDate: [''],
            petMemo: [''],

            isImageChanged: false,
            delImageInfo: [],

            isModify: false,
            modifyID: 0,

            isUpdated: false,

            swiperOptions: {
                navigation: false,
                pagination: {
                    type: 'bullets',
                    dynamicBullets: true,
                },
                slidesPerView: 1,
                spaceBetween: 50,
            },
            modules: [Navigation, Pagination, Scrollbar]
        }
    },

    watch: {
        //생일 체크
        petBirth(a){
            if (/\D/g.test(a)){
                this.$store.commit('setAlert', {
                                                'alertStatus': 'notice'
                                                ,'alertTitle': '입양 현황 관리'
                                                ,'alertContent': `숫자만 입력하세요`
                                            });
                this.petBirth = a.substring(0, a.length - 1);
            }
            if(a.length >= 6){
                $('.petBirth').focus();
            }
        },
    },

    methods: {
        //메모일 포맷
        formatMemoDate(id){
            id = Number(id);
            const date = this.petMemoDate[id]?new Date(this.petMemoDate[id]):new Date();
            const day = date.getDate();
            const month = date.getMonth() + 1;
            const year = date.getFullYear();
    
            return `${year}/${month}/${day}`;
        },

        //메모 추가
        addMemo(){
            this.petMemo = this.petMemo.filter(a => {if(a != '') return a;});
            this.petMemo.push('');
            this.petMemoDate.push('');
        },

        //메모 삭제
        deleteMemo(id){
            this.petMemo.splice(id, 1);
            this.petMemoDate.splice(id, 1);
        },

        resizeImage(file, callback) {
            if(!file) return;

            const reader = new FileReader();
            reader.onload = (e) => {
                const img = new Image();
                img.onload = () => {
                    const canvas = document.createElement("canvas");
                    const ctx = canvas.getContext("2d");

                    const max_width = 1024;
                    const max_height = 1024;
                    let width = img.width;
                    let height = img.height;

                    if (width > height) {
                        if (width > max_width) {
                            height *= max_width / width;
                            width = max_width;
                        }
                    } else {
                        if (height > max_height) {
                            width *= max_height / height;
                            height = max_height;
                        }
                    }

                    canvas.width = width;
                    canvas.height = height;
                    ctx.drawImage(img, 0, 0, width, height);

                    canvas.toBlob((blob) => {
                        let newFile = new File([blob], file.name, {
                            type: "image/jpeg",
                            lastModified: Date.now(),
                        });

                        newFile.src = URL.createObjectURL(newFile);
                        newFile.location = URL.createObjectURL(newFile);

                        
                        
                        callback(newFile); // 콜백으로 처리된 파일을 반환
                    }, "image/jpeg");
                };
                img.src = e.target.result;
            };
            reader.readAsDataURL(file);
        },

        //첨부파일 변경 시
        petImageChanged(){
            let fileUploader = document.getElementById('petImage');
            let files = fileUploader.files;
            let resizedImages = []; // 조정된 이미지를 저장할 배열

            Array.from(files).forEach(file => {
                console.log('before', file);
                this.resizeImage(file, (resizedImage) => {
                    console.log('after', resizedImage);
                    resizedImages.push(resizedImage);
                    if(resizedImages.length === files.length) {

                        if(this.manageMode == 'select') { //편집 모드
                            this.isImageChanged = true;
                            this.delImageInfo = this.petImage.map(a => a.key);
                        }

                        // 모든 이미지가 처리된 후 상태 업데이트
                        this.petImage = resizedImages;
                        console.log('result', this.petImage);
                    }
                });
            });
        },

        //즐겨찾기 여부 변경
        setFavor(){
            this.isFavorite = !this.isFavorite;
        },

        //편집 모드
        modifyMode(id){
            $('.editArea').attr('class', 'card editArea');

            this.modifyID = id;
            let tempInfo = this.$store.state.hondi.adoptInfo.find(a => a._id == id);

            //데이터 바인딩
            this.isFavorite = tempInfo.isFavorite;

            this.petImage = tempInfo.petImage??[];
            this.petName = tempInfo.petName??'';
            this.petGender = tempInfo.petGender??'';
            this.petBirth = tempInfo.petBirth??'';
            this.petAge = tempInfo.petAge??'';
            this.petWeight = tempInfo.petWeight??'';
            this.petKind = tempInfo.petKind??'';
            this.petBreed = tempInfo.petBreed??'';
            this.petRegNum = tempInfo.petRegNum??'';
            this.petAdopt = tempInfo.petAdopt??false;
            this.petAdoptDate = tempInfo.petAdoptDate??'';
            this.petNeutral = tempInfo.petNeutral??false;
            this.petTreat = tempInfo.petTreat??false;
            this.petMedical = tempInfo.petMedical??'';
            this.petHealth = tempInfo.petHealth??'';
            this.petRescue = tempInfo.petRescue??'';

            this.petMemo = tempInfo.petMemo;
            this.petMemoDate = tempInfo.petMemoDate;

            this.isImageChanged = false;

            //왼쪽 정보 편집 창 상태 변경(버튼, border color 등 편집 상태임을 확인할 수 있도록)
            this.isModify = true;
            tempInfo = '';
            //$('.class-' + this.modifyID).attr('class', 'list-group-item border-danger border-top p-4 mb-2 mb-3 bg-gray-100 border-radius-lg class-' + this.modifyID);
            $('.editArea').attr('class', 'card editArea border border-danger');
        },

        //입력 모드
        insertMode(){
            this.isModify = false;

            this.isFavorite = false;

            this.petImage = [],
            this.petName = '';
            this.petGender = '';
            this.petBirth = '';
            this.petAge = '';
            this.petWeight = '';
            this.petKind = '';
            this.petBreed = '';
            this.petRegNum = '';
            this.petAdopt = false;
            this.petAdoptDate = '';
            this.petNeutral = false;
            this.petTreat = false;
            this.petMedical = '';
            this.petHealth = '';
            this.petRescue = '';

            this.petMemo = [''];
            this.petMemoDate = [''];

            this.isImageChanged = false;

            $('.class-' + this.modifyID).attr('class', 'list-group-item border-0 p-4 mb-2 mb-3 bg-gray-100 border-radius-lg class-' + this.modifyID);
            $('.editArea').attr('class', 'card editArea');
            this.modifyID = 0;

            this.toggleManage();
        },

        //편집 저장
        modifyAdoptInfo(){
            this.$store.dispatch('modifyAdoptInfo', {   id: this.modifyID
                                                        ,isFavorite: this.isFavorite
                                                        ,petImage: this.petImage
                                                        ,petName: this.petName
                                                        ,petGender: this.petGender
                                                        ,petBirth: this.petBirth
                                                        ,petAge: this.petAge
                                                        ,petWeight: this.petWeight
                                                        ,petKind: this.petKind
                                                        ,petBreed: this.petBreed
                                                        ,petRegNum: this.petRegNum
                                                        ,petAdopt: this.petAdopt
                                                        ,petAdoptDate: this.petAdoptDate
                                                        ,petNeutral: this.petNeutral
                                                        ,petTreat: this.petTreat
                                                        ,petMedical: this.petMedical
                                                        ,petHealth: this.petHealth
                                                        ,petRescue: this.petRescue
                                                        ,petMemo: this.petMemo.filter(a => {if(a != '') return a;}).length ? this.petMemo.filter(a => {if(a != '') return a;}) : ['']
                                                        ,petMemoDate: this.petMemoDate.filter((a, b) => this.petMemo[b] != '').length
                                                                    ?this.petMemoDate.filter((a, b) => this.petMemo[b] != '').map((a) => {return a?new Date(a).toLocaleDateString('ko-KR'):''}) 
                                                                    :['']
                                                        ,updateDate: new Date().toLocaleString('ko-KR')
                                                        ,updateId: this.$store.state.login.loginID
                                                        ,isImageChanged: this.isImageChanged
                                                        ,delImageInfo: this.delImageInfo
                                                    });
            this.insertMode();
        },

        //입력 저장
        insertAdoptInfo(){
            this.$store.dispatch('insertAdoptInfo', {  isFavorite: this.isFavorite
                                                        ,petImage: this.petImage
                                                        ,petName: this.petName
                                                        ,petGender: this.petGender
                                                        ,petBirth: this.petBirth
                                                        ,petAge: this.petAge
                                                        ,petWeight: this.petWeight
                                                        ,petKind: this.petKind
                                                        ,petBreed: this.petBreed
                                                        ,petRegNum: this.petRegNum
                                                        ,petAdopt: this.petAdopt
                                                        ,petAdoptDate: this.petAdoptDate
                                                        ,petNeutral: this.petNeutral
                                                        ,petTreat: this.petTreat
                                                        ,petMedical: this.petMedical
                                                        ,petHealth: this.petHealth
                                                        ,petRescue: this.petRescue
                                                        ,petMemo: this.petMemo.filter(a => {if(a != '') return a;}).length ? this.petMemo.filter(a => {if(a != '') return a;}) : ['']
                                                        ,petMemoDate: this.petMemoDate.filter((a, b) => this.petMemo[b] != '').length
                                                                    ?this.petMemoDate.filter((a, b) => this.petMemo[b] != '').map((a) => {return a?new Date(a).toLocaleDateString('ko-KR'):''}) 
                                                                    :['']
                                                        ,insertDate: new Date().toLocaleString('ko-KR')
                                                        ,insertId: this.$store.state.login.loginID
                                                    });
            this.insertMode();
        },

        //삭제
        deleteAdoptInfo(){
            this.$store.commit('setAlert', {
                                                'alertStatus': 'confirm'
                                                ,'alertTitle': '입양현황 관리'
                                                ,'alertContent': `선택한 정보를 삭제하시겠습니까?|1. 유기동물명: ${this.petName}|2. 유기동물 정보(품종/나이): ${this.petKind}/${this.petAge}| |**삭제한 정보는 복구할 수 없으므로 신중히 삭제하시기 바랍니다.}`
                                                ,'callback': 'deleteAdoptInfo'
                                                ,'parameter': {id: this.modifyID}
                                            }
                            );
            this.insertMode();
        },
    },

    mounted() {
        if(this.manageMode == 'select' && !this.isUpdated){
            this.modifyMode(this.adoptionID);
            this.isUpdated = !this.isUpdated;
        }
    },

    updated(){
        if(this.manageMode == 'select' && !this.isUpdated){
            this.modifyMode(this.adoptionID);
            this.isUpdated = !this.isUpdated;
        }
    },
}
</script>

<style>

</style>